/**
 * @generated SignedSource<<fa665cdccb7f190cf2510bc7a87fe060>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ConnectedWalletStatus_user$data = {
  readonly ethereumWalletAddress: {
    readonly address: string | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"ConnectedWalletMobileMenu_user" | "ConnectedWalletRespMenu_user">;
  readonly " $fragmentType": "ConnectedWalletStatus_user";
};
export type ConnectedWalletStatus_user$key = {
  readonly " $data"?: ConnectedWalletStatus_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"ConnectedWalletStatus_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ConnectedWalletStatus_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ConnectedWalletRespMenu_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ConnectedWalletMobileMenu_user"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EthereumAddressType",
      "kind": "LinkedField",
      "name": "ethereumWalletAddress",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "address",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "e14d22ec73e39bb9499b6c27f78a6b4c";

export default node;
